// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"21bc936a","822":"08678a4c"}[chunkId] + ".chunk.js";
};